import { render, staticRenderFns } from "./PendingShipments.vue?vue&type=template&id=6d387a08&scoped=true"
import script from "./PendingShipments.vue?vue&type=script&lang=ts"
export * from "./PendingShipments.vue?vue&type=script&lang=ts"
import style0 from "./PendingShipments.vue?vue&type=style&index=0&id=6d387a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d387a08",
  null
  
)

export default component.exports